import { useState, useEffect } from "react";
import { site } from "@/mocks/heigua";

const navLinks = [
  { label: "档案检索", href: "#library" },
  { label: "时间线", href: "#timeline" },
  { label: "旧料精选", href: "#featured" },
  { label: "经典合集", href: "#collections" },
  { label: "深度回顾", href: "#deep" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const barStyle = scrolled
    ? "border-background-200 bg-background-50/90 backdrop-blur-md"
    : "border-transparent bg-transparent";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 border-b transition-all duration-300 ${barStyle}`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#start" className="group flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-accent-500 text-primary-950"
            }`}
          >
            <i className="ri-archive-fill text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold tracking-tight transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              {site.name}
            </span>
            <span
              className={`mt-0.5 text-[11px] tracking-wide transition-colors ${
                scrolled ? "text-foreground-500" : "text-background-300/90"
              }`}
            >
              {site.slogan}
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="主导航">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap text-sm transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-100 hover:text-accent-300"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#featured"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            开始翻老料
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            className={`flex h-9 w-9 items-center justify-center rounded-md border transition-colors lg:hidden ${
              scrolled
                ? "border-background-200 bg-background-50 text-foreground-800"
                : "border-background-200/40 bg-background-50/10 text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-100 px-1 py-3 text-sm text-foreground-800 last:border-0"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#featured"
              onClick={() => setMenuOpen(false)}
              className="mt-3 rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              开始翻老料
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}